<script lang="ts">
    
    import { onMount } from "svelte";
    import { Button, Table, Modal, ModalHeader, ModalBody, Icon, TabContent, TabPane, Badge } from "sveltestrap";
    import type { User } from "../../Model/User";
    import { accountsService, userFactory, usersService } from "../../Services";
    import ManagerIcon from "../Manager/ManagerIcon.svelte";
    import NumEndedGames from "../Manager/NumEndedGames.svelte";
import DateFormatter from "../Shared/DateFormatter.svelte";
    import DisabledBadge from "../Shared/DisabledBadge.svelte";
    import EnabledBadge from "../Shared/EnabledBadge.svelte";
    import UserForm from "../Users/UserForm.svelte";
    import Watch from "../Watch.svelte";

    export let accountId: string;

    let managers: User[] = [];
    let openFormModal = false;
    let currentManager: User;
    let isNew = false;

    onMount(mount);

    async function mount(): Promise<void> {
        managers = await accountsService.getAccountUsers(accountId);
    }

    function toggleFormModal(): void {
        openFormModal = !openFormModal;
    }

    function onCreateManager(): void {
        currentManager = userFactory.createUser(undefined, accountId);
        isNew = true;
        openFormModal = true;
    }

    function editManager(manager: User): void {
        currentManager = manager;
        isNew = false;
        openFormModal = true;
    }

    function onManagerSaved(): void {
        openFormModal = false;
        if (isNew) {
            managers = [...managers, currentManager];
        }
    }

    async function onDeleteManager(): Promise<void> {
        if (!confirm('¿Seguro que desea eliminar el animador?')) {
            return;
        }
        try {
            await usersService.deleteUser(currentManager.id);
            openFormModal = false;
            managers = managers.filter(({ id }) => id !== currentManager.id);
            currentManager = undefined;
        } catch (error) {
            console.error(error);
        }
    }

</script>

<Button type="button" color="primary" size="sm" on:click={onCreateManager}>
    <ManagerIcon /> Crear animador
</Button>

<Table>

    <thead>
        <tr>
            <th>Nombre</th>
            <th>Estado</th>
            <th>Juegos</th>
            <th>Último acceso</th>
            <th>Creado</th>
            <th></th>
        </tr>
    </thead>

    <tbody>
        {#each managers as manager}
            <tr>
                <td><Watch state={manager.name} /></td>
                <td>
                    <Watch state={manager.enabled} let:value={enabled}>
                        {#if enabled}
                            <EnabledBadge />
                        {:else}
                            <DisabledBadge />
                        {/if}
                    </Watch>
                </td>
                <td>
                    <NumEndedGames managerId={manager.id} let:count>
                        <Badge color={count > 0 ? 'success' : 'warning'}>{count} juegos</Badge>
                    </NumEndedGames> 
                </td>
                <td>
                    <DateFormatter date={manager.lastLoginDate} />
                </td>
                <td>
                    <DateFormatter date={manager.creationDate} />
                </td>
                <td class="text-end">
                    <Button type="button" color="primary" size="sm" on:click={() => editManager(manager)}>
                        <Icon name="pencil" />
                    </Button>
                </td>
            </tr>
        {/each}
    </tbody>

</Table>

<Modal isOpen={openFormModal}>
    <ModalHeader toggle={toggleFormModal}>
        Editar animador
    </ModalHeader>
    <ModalBody>
        <TabContent>
            <TabPane tabId="form" tab="Editar" active class="pt-3">
                <UserForm user={currentManager} on:saved={onManagerSaved} />
            </TabPane>
            {#if !isNew}
                <TabPane tabId="delete" tab="Eliminar" class="pt-3">
                    <Button type="button" color="danger" on:click={onDeleteManager}>
                        <Icon name="x" /> Eliminar
                    </Button>
                </TabPane>
            {/if}
        </TabContent>
    </ModalBody>
</Modal>